/**
 * Teto de opções por enquete. Espelha `MAX_UPLOAD_FILES` do interactive-area-service:
 * cada opção pode levar uma imagem, e o backend recusa a requisição inteira acima disso.
 * Se mudar aqui, mudar lá (src/utils/uploads.ts do serviço).
 */
export const MAX_POLL_OPTIONS = 25;
